export default "__VITE_ASSET__DRyBEJob__"